export const availableComponents = {
  lobby: [
    { type: "banners", name: "mell.components.banners", icon: "banners" },
    { type: "categories", name: "mell.components.categories", icon: "categories" },
    { type: "gamesRow", name: "mell.components.gamesRow", icon: "games_row" },
    { type: "slotsSwiper", name: "mell.components.slotsSwiper", icon: "games_row" },
    { type: "totalJackpot", name: "mell.components.totalJackpot", icon: "jackpot" },
    { type: "highlightGame", name: "mell.components.highlightGame", icon: "highlight_game" },
    { type: "randomGame", name: "mell.components.randomGame", icon: "random_game" },
    { type: "latestWins", name: "mell.components.latestWins", icon: "last_wins" },
    { type: "middleBanner", name: "mell.components.middleBanner", icon: "middle_banner" },
    { type: "gamesGrid", name: "mell.components.gamesGrid", icon: "games_grid" },
    { type: "providersSlider", name: "mell.components.providersSlider", icon: "providers_slider" },
  ],
  information: [{ type: "textBlock", name: "mell.components.textBlock", icon: "text" }],
  profile: [{ type: "profileButton", name: "mell.components.profileButton", icon: "profile_button" }],
  promotions: [{ type: "promotion", name: "mell.components.promotion", icon: "promo" }],
  bonuses: [{ type: "bonus", name: "mell.components.bonus", icon: "bonus" }],
  wallet: [],
  filters: [
    { type: "gamesRow", name: "mell.components.gamesRow", icon: "games_row" },
    { type: "top_providers", name: "mell.components.top_providers", icon: "top_providers" },
  ],
  liveCasino: [{ type: "banners", name: "mell.components.banners", icon: "banners" }],
}

export const componentListHeaders = {
  lobby: "mell.componentListHeaders.lobby",
  information: "mell.componentListHeaders.information",
  profile: "mell.componentListHeaders.profile",
  promotions: "mell.componentListHeaders.promotions",
  bonuses: "mell.componentListHeaders.bonuses",
  wallet: "mell.componentListHeaders.wallet",
  filters: "mell.componentListHeaders.filters",
  liveCasino: "mell.componentListHeaders.liveCasino",
}
